module.exports = __webpack_public_path__ + "static/media/arrow-right.dbab86bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = 238
// module chunks = 0